import { PlayerConfig, PlayerConfigProps } from '../types/config';

export const createPlayerConfigProps = (config: PlayerConfig): PlayerConfigProps => {
    const { autostart } = config;
    const commonProps = { autostart };

    if (config.configType === 'readySource') {
        return { source: config.source, ...commonProps };
    }
    if (config.configType === 'sourceCallback') {
        return { getSource: config.getSource, ...commonProps };
    }

    return { graphQLRequester: config.graphQLRequester, ...commonProps };
};
